import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Sidebar from "../pages/components/Sidebar";
import Topbar from "../pages/components/Topbar";
import MemberDetailsReportCard from "../../admin/components/report/MemberDetailsReportCard";

const MemberDetailsReport = ({ token, distributor }) => {

    const history = useHistory();

    const location = useLocation();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!location.state || !distributor || !distributor.user_detail) {
            history.push('/distributor')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <MemberDetailsReportCard
                        token={token}
                        country={distributor.country}
                        stampSetting={distributor.stamp}
                        tokenSetting={distributor.token}
                        pointSetting={distributor.loyalty_point}
                        userId={location.state?.userId}
                        memberId={location.state?.memberId}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(MemberDetailsReport);
